
// import React, { useEffect } from "react";
// const Toast = ({ message, type = "success", onClose }) => {
//     useEffect(() => {
//       const timer = setTimeout(onClose, 300000000);
//       return () => clearTimeout(timer);
//     }, [onClose]);
  
//     if (!message) return null;
  
//     const backgroundColor = type === "success" ? "#4caf50" : "#f44336"; // green or red
  
//     return (
//       <div
//         className="toast"
//         style={{
//             backgroundColor,
//             color: "#fff",
//             padding: "10px 20px",
//             borderRadius: "6px",
//             position: "fixed",
//             top: "20px",
//             right: "20px",
//             zIndex: 9999,
//             boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.2)"
//           }}
          
//       >
//         {message}
//       </div>
//     );
//   };
//   export default Toast;
import React, { useEffect } from "react";

const Toast = ({ title = "Success", message, type = "success", onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  if (!message) return null;

  const borderColor = type === "success" ? "#4caf50" : "#f44336";
  const icon = (
    <div
      style={{
        width: '25px',
        height: '25px',
        borderRadius: '50%',
        backgroundColor: type === 'success' ? '#4caf50' : '#f44336',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {type === 'success' ? (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="#ffffff"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
        </svg>
      ) : (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="#ffffff"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M18.3 5.71L12 12.01 5.71 5.71 4.29 7.12 10.59 13.41 4.29 19.71 5.71 21.12 12 14.83 18.3 21.12 19.71 19.71 13.41 13.41 19.71 7.12z" />
        </svg>
      )}
    </div>
  );
  

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        backgroundColor: "#fff",
        padding: "16px",
        borderRadius: "8px",
        boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
        borderLeft: `10px solid ${borderColor}`,
        position: "fixed",
        top: "20px",
        right: "20px",
        minWidth: "300px",
        zIndex: 9999,
        fontFamily: "sans-serif",
      }}
    >
      <div style={{ marginRight: "12px", fontSize: "15px" }}>
        {icon}
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: "bold", fontSize: "16px", color: "#333" }}>
          {title}
        </div>
        <div style={{ fontSize: "14px", color: "#666" }}>{message}</div>
      </div>
      <div
        onClick={onClose}
        style={{
          marginLeft: "12px",
          cursor: "pointer",
          fontSize: "8px",
          color: "#999",
        }}
        title="Close"
      >
        ✖️
      </div>
    </div>
  );
};

export default Toast;

